module.exports = __webpack_public_path__ + "static/story3-aa9d60cc5965a86b407afdb1f81e3afd.png";